import React, { useState } from 'react';
import { LockIcon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import type { LoginSubmission } from '../../data/contracts';
interface DashboardLoginProps {
  onLoginRequested?: (payload: LoginSubmission) => void | Promise<void>;
}
export function DashboardLogin({
  onLoginRequested
}: DashboardLoginProps) {
  const [noticeVisible, setNoticeVisible] = useState(false);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const payload: LoginSubmission = {
      username: String(form.get('username') || ''),
      password: String(form.get('password') || '')
    };
    onLoginRequested?.(payload);
    setNoticeVisible(true);
  };
  return <main className="flex-grow relative flex items-center justify-center pt-48 pb-40 lg:pb-52 px-4 min-h-screen" data-id="element-16">
      <div className="absolute inset-0 z-0" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/xfAj77taGj8Z7M4Qc8mYyx/ChatGPT_Image_Mar_27,_2026,_12_37_09_PM.png" alt="Vanguard Warriors" className="w-full h-full object-cover object-center" data-id="element-18" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-darkBlue/40" data-id="element-19" />
      </div>

      <motion.section initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="glass-panel rounded-2xl p-8 md:p-12 w-full max-w-md relative z-10 border-gold/20 shadow-[0_0_50px_rgba(212,175,55,0.1)]" aria-labelledby="dashboard-login-title" data-id="element-20">
        <div className="text-center mb-8" data-id="element-21">
          <div className="w-16 h-16 mx-auto bg-darkerBlue rounded-full border border-gold/30 flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-22">
            <UserIcon className="w-8 h-8 text-gold" data-id="element-23" />
          </div>
          <h1 id="dashboard-login-title" className="text-3xl font-bold font-cinzel mb-2" data-id="element-24">
            Iniciar Sesión
          </h1>
          <p className="text-gray-400" data-id="element-25">Accede a tu cuenta de Vanguard</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form" data-id="element-26">
          <div data-id="element-27">
            <label htmlFor="login-username" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-28">
              Usuario
            </label>
            <div className="relative" data-id="element-29">
              <UserIcon className="absolute inset-y-0 left-3 my-auto h-5 w-5 text-gray-500" aria-hidden="true" data-id="element-30" />
              <input id="login-username" name="username" type="text" required autoComplete="username" data-testid="login-username-input" className="block w-full pl-10 pr-3 py-3 border border-white/10 rounded-lg bg-darkerBlue/50 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gold/50" placeholder="Usuario" data-id="element-31" />
            </div>
          </div>

          <div data-id="element-32">
            <label htmlFor="login-password" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-33">
              Contraseña
            </label>
            <div className="relative" data-id="element-34">
              <LockIcon className="absolute inset-y-0 left-3 my-auto h-5 w-5 text-gray-500" aria-hidden="true" data-id="element-35" />
              <input id="login-password" name="password" type="password" required autoComplete="current-password" data-testid="login-password-input" className="block w-full pl-10 pr-3 py-3 border border-white/10 rounded-lg bg-darkerBlue/50 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gold/50" placeholder="••••••••" data-id="element-36" />
            </div>
          </div>

          <button type="submit" data-testid="login-submit" className="w-full btn-primary py-3 text-lg mt-4" data-id="element-37">
            Entrar al Portal
          </button>
        </form>

        {noticeVisible && <p role="status" data-testid="login-integration-notice" className="mt-5 text-center text-sm text-gold" data-id="element-38">
            La autenticación se conectará al servicio de cuenta al integrar el
            backend.
          </p>}

        <div className="mt-8 text-center border-t border-white/10 pt-6" data-id="element-39">
          <p className="text-gray-400 text-sm" data-id="element-40">
            ¿No tienes cuenta?{' '}
            <a href="/#register" className="text-gold hover:text-yellow-400 font-semibold transition-colors" data-id="element-41">
              Regístrate aquí
            </a>
          </p>
        </div>
      </motion.section>
    </main>;
}